export default "__VITE_ASSET__Delu8fzz__"